import React, { useEffect, useState } from "react";
import { Group } from "@visx/group";
import { Circle, Line } from "@visx/shape"; // Ensure Line is imported
import { AxisLeft, AxisBottom } from "@visx/axis";
import { scaleLinear, scaleSymlog } from "@visx/scale";
import {
  TooltipWithBounds,
  defaultStyles as tooltipStyles,
} from "@visx/tooltip";
import { localPoint } from "@visx/event";

const CommonScatterChart = ({
  width,
  height,
  margin,
  data,
  r = 1,
  ADM = null,
  yRefLine = 0,
  isOpen = false,
}) => {

  const [newData,setNewData]=useState([])
  useEffect(() => {
    if (data && data.length) {

      const filteredData = data.filter((point) => point.x !== 0 && point.y !== 0);
      setNewData(filteredData);
    } else {
      setNewData([]);
    }
  }, [width, height, data, ADM, yRefLine, r]);
  
  // const [tooltipData, setTooltipData] = useState(null);
  // const [tooltipTop, setTooltipTop] = useState(0);
  // const [tooltipLeft, setTooltipLeft] = useState(0);

  // Define the scales
  const xScale = scaleLinear({
    domain: [0, 4],
    range: [margin.left, width - margin.right],
  });

  const maxY = Math.max(...newData.map((item) => item.y));
  const domain = [0, maxY < yRefLine ? yRefLine+2:maxY];
  const range = [height - margin.bottom, margin.top];

  /* The `yScale` constant in the provided code snippet is determining the scale function to be used
  based on the value of the `ADM` variable. */
  const yScale =
    ADM === "ADM1"
      ? scaleLinear({
          domain: domain,
          range: range,
        })
      : /* The `scaleSymlog` function is creating a scale function for a symmetrical log scale. In the
      provided code snippet, it is being used to define the `yScale` based on the value of the
      `ADM` variable. */
        scaleSymlog({
          domain: domain,
          range: range,
          constant: 5, //An optional constant factor to adjust the scale
        });

  // Tooltip handler
  const handleMouseOver = (event, datum) => {
    const coords = localPoint(event.target.ownerSVGElement, event) || {
      x: 0,
      y: 0,
    };
    // setTooltipData(datum);
    // setTooltipTop(coords.y);
    // setTooltipLeft(coords.x);
  };

  // Calculate middle positions for the lines
  // const middleX = xScale(Math.max(...data.map(d => d.x)) / 2);
  const middleX =newData.length? xScale(2): xScale(0);
  const middleY =newData.length? yScale(yRefLine): yScale(0);

  return (
    <div>
        <svg width={width} height={height + 25}>
          <Group>
            {newData.map((point, i) => (
              <Circle
                key={i}
                cx={xScale(point.x)}
                cy={yScale(point.y)}
                r={r}
                fill="#08977d"
                // onMouseOver={(event) => handleMouseOver(event, point)}
                // onMouseOut={() => setTooltipData(null)}
              />
            ))}
            {/* Middle line for X-axis */}
            {newData.length && <Line
              from={{ x: margin.left, y: middleY }}
              to={{ x: width - margin.right, y: middleY }}
              stroke="blue"
              // strokeWidth={2}
              // strokeDasharray="1, 5"
              strokeWidth={0.5}
              strokeDasharray="5, 5"
            />}
            {/* Middle line for Y-axis */}
            {newData.length && <Line
              from={{ x: middleX, y: margin.top }}
              to={{ x: middleX, y: height - margin.bottom }}
              stroke="blue"
              // strokeWidth={2}
              // strokeDasharray="1, 5"
              strokeWidth={0.5}
              strokeDasharray="5, 5"
            />}
            <text
              x={(width - margin.left - margin.right) / 2 + margin.left}
              y={height + 12}
              textAnchor="middle"
              fill="black"
              fontFamily="Open Sans"
              fontSize={11}
              fontWeight={isOpen ? "bold" : "normal"}
            >
              Network Performance Ranking
            </text>
            {/* Y-axis label */}
            <text
              x={10}
              y={(height - margin.top - margin.bottom) / 2 + margin.top}
              textAnchor="middle"
              fill="black"
              transform={`rotate(-90, 10, ${
                (height - margin.top - margin.bottom) / 2 + margin.top
              })`}
              fontFamily="Open Sans"
              fontSize={11}
              fontWeight={isOpen ? "bold" : "normal"}
            >
              Market Share %
            </text>
            <text
            x={margin.left - 10}
            y={middleY}  // Align with horizontal middle line
            dy=".32em"  // Center align text vertically
            textAnchor="end"  // Right align text
            fill="black"  // Make text blue to match line color
            fontFamily="Open Sans"
            fontSize={11}
          >
           {/* {yScale.invert(middleY).toFixed(2)} */}
           {Math.round(yScale.invert(middleY))}
          </text>
          </Group>
          <AxisLeft left={margin.left} scale={yScale} />
          <AxisBottom top={height - margin.bottom} scale={xScale} />
        </svg>
      {/* {tooltipData && (
        <TooltipWithBounds
          top={tooltipTop}
          left={tooltipLeft}
          style={tooltipStyles}
        >
          <div>
            <strong>x:</strong> {tooltipData.x}
          </div>
          <div>
            <strong>y:</strong> {tooltipData.y}
          </div>
        </TooltipWithBounds>
      )} */}
    </div>
  );
};

export default CommonScatterChart;
